import React, { useState } from 'react';
import smsIcon from "../../assets/lock.png";
import statusIcon from "../../assets/status.png"

const PasswordPopup = ({ onClose }) => {
    return (
        <div className="popup-overlay p-4">
            <div className="popup-content p-4">
                <img src={statusIcon} style={{width:"50px", height:"50px"}}/>
                <h5 className='sub-title my-4'>Your password has been
                updated successfully!</h5>
                <button onClick={onClose} className="dark-orange-button px-4" style={{fontSize:"15px"}}>Okay!</button>
            </div>
        </div>
    );
};

const ChangePassword = () => {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [showPopup, setShowPopup] = useState(false);  // State to control popup visibility

    const validate = () => {
        const newErrors = {};
        if (!oldPassword) newErrors.oldPassword = 'Old password is required';
        if (!newPassword) {
            newErrors.newPassword = 'New password is required';
        } else {
            const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
            if (!regex.test(newPassword)) {
                newErrors.newPassword = 'Password does not meet requirements';
            }
        }
        if (confirmPassword !== newPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }
        return newErrors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            console.log("Password changed!");
            setShowPopup(true);  // Show popup when validation passes
        }
    };

    const handlePopupClose = () => {
        setShowPopup(false);  // Close the popup
    };

    return (
        <div className='mt-4'>
            <form onSubmit={handleSubmit} className="mb-4 bg-white rounded">
                <h5 className="mb-2 sub-title">Change password</h5>
                <p className="gray-text-for-content mb-4">Update your password to a password you have not previously used.</p>

                <div className='row'>
                    <div className="mb-4 col-4">
                        <label className="d-block text-start">Old Password</label>
                        <div className="position-relative">
                            <input
                                type="password"
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                                placeholder="Enter old password"
                                className={`input-base gray-text-for-content ${errors.oldPassword ? 'border border-danger' : ''}`}
                            />
                            <div className="input-start-icon-image"><img src={smsIcon} alt="" /></div>
                        </div>
                        {errors.oldPassword && <div className="text-danger mt-1 text-sm">{errors.oldPassword}</div>}
                    </div>

                    <div className="mb-4 col-4">
                        <label className="d-block text-start">New Password</label>
                        <div className="position-relative">
                            <input
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Enter new password"
                                className={`input-base gray-text-for-content ${errors.newPassword ? 'border border-danger' : ''}`}
                            />
                            <div className="input-start-icon-image"><img src={smsIcon} alt="" /></div>
                        </div>
                        {errors.newPassword && <div className="text-danger mt-1">{errors.newPassword}</div>}
                    </div>

                    <div className="mb-4 col-4">
                        <label className="d-block text-start">Confirm New Password</label>
                        <div className="position-relative">
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Enter new password"
                                className={`input-base gray-text-for-content ${errors.confirmPassword ? 'border border-danger' : ''}`}
                            />
                            <div className="input-start-icon-image"><img src={smsIcon} alt="" /></div>
                        </div>
                        {errors.confirmPassword && <div className="text-danger mt-1">{errors.confirmPassword}</div>}
                    </div>
                </div>

                <div className='mt-3'>
                    <h6 className='gray-text-for-content mb-3'>Password Requirements</h6>
                    <p className='gray-text-for-content'>1. Must contain at least 1 number</p>
                    <p className='gray-text-for-content'>2. Must contain at least 1 upper-case letter</p>
                    <p className='gray-text-for-content'>3. Must contain at least 1 lower-case letter</p>
                    <p className='gray-text-for-content'>4. Must contain at least 1 non-alphanumeric character (e.g. !@#$)</p>
                    <p className='gray-text-for-content'>5. Must contain at least 8 characters</p>
                </div>

                <div className='text-center'>
                    <button type="submit" className="dark-orange-button px-4">Change Password</button>
                </div>
            </form>

            {showPopup && <PasswordPopup onClose={handlePopupClose} />}
        </div>
    );
};

export default ChangePassword;
